export const ASSIGN_GROUPS_PERMISSIONS = "ASSIGN_GROUPS_PERMISSIONS";
export const RESET_GROUPS_PERMISSIONS = "RESET_GROUPS_PERMISSIONS";
